import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./HomePage.css";

const HomePage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  //   const curr = location.hash

  const [activeTab, setActiveTab] = useState("");
  const [toggle, setToggle] = useState(false);

  //   console.log(curr);

  useEffect(() => {
    const curr = location.hash;
    setActiveTab(curr);
  }, [location.hash]);

  const destinations = [
    {
      id: 1,
      name: "Paris, France",
      price: "From ₹899",
      image:
        "https://images.unsplash.com/photo-1502602898536-47ad22581b52?w=600&h=400&fit=crop",
      description:
        "The City of Light awaits with its iconic landmarks and romantic charm",
      rating: 4.8,
    },
    {
      id: 2,
      name: "Tokyo, Japan",
      price: "From ₹1299",
      image:
        "https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=600&h=400&fit=crop",
      description: "Where ancient traditions meet cutting-edge innovation",
      rating: 4.9,
    },
    {
      id: 3,
      name: "Bali, Indonesia",
      price: "From ₹799",
      image:
        "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=600&h=400&fit=crop",
      description: "Tropical paradise with stunning beaches and rich culture",
      rating: 4.7,
    },
    {
      id: 4,
      name: "Dubai, UAE",
      price: "From ₹1099",
      image:
        "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=600&h=400&fit=crop",
      description: "Luxury and adventure in the heart of the desert",
      rating: 4.6,
    },
    {
      id: 5,
      name: "London, UK",
      price: "From ₹999",
      image:
        "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=600&h=400&fit=crop",
      description: "Historic charm meets modern sophistication",
      rating: 4.5,
    },
    {
      id: 6,
      name: "New York, USA",
      price: "From ₹1199",
      image:
        "https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=600&h=400&fit=crop",
      description: "The city that never sleeps, full of endless possibilities",
      rating: 4.8,
    },
  ];

  const services = [
    {
      icon: "fas fa-plane",
      title: "Flight Bookings",
      description:
        "Discover the best flight deals worldwide with our exclusive partnerships and real-time pricing",
      features: ["Best Price Guarantee", "Flexible Dates", "24/7 Support"],
      color: "#3b82f6",
    },
    {
      icon: "fas fa-hotel",
      title: "Hotel Reservations",
      description:
        "From luxury resorts to cozy boutique hotels, find the perfect accommodation for your stay",
      features: [
        "Premium Properties",
        "Instant Confirmation",
        "Free Cancellation",
      ],
      color: "#10b981",
    },
    {
      icon: "fas fa-map-marked-alt",
      title: "Tour Packages",
      description:
        "Carefully curated travel experiences with expert local guides and authentic cultural immersion",
      features: [
        "Expert Guides",
        "Cultural Immersion",
        "All-Inclusive Options",
      ],
      color: "#f59e0b",
    },
    {
      icon: "fas fa-passport",
      title: "Visa Services",
      description:
        "Hassle-free visa processing with dedicated support to ensure smooth travel documentation",
      features: ["Fast Processing", "Document Support", "Status Tracking"],
      color: "#8b5cf6",
    },
  ];

  const testimonials = [
    {
      name: "Sarah Johnson",
      location: "New York, USA",
      rating: 5,
      text: "Bright Wings made our European vacation absolutely perfect. The attention to detail and customer service was exceptional.",
      image:
        "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop&crop=face",
      trip: "European Grand Tour",
    },
    {
      name: "Michael Chen",
      location: "Singapore",
      rating: 5,
      text: "The visa processing was incredibly smooth and fast. I got my documents approved much quicker than expected.",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
      trip: "Business Travel to Europe",
    },
    {
      name: "Emily Davis",
      location: "London, UK",
      rating: 5,
      text: "Amazing tour packages with authentic local experiences. Every moment was carefully planned and executed beautifully.",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
      trip: "Asian Cultural Discovery",
    },
  ];

  return (
    <div className="home-page">
      {/* Navigation */}
      <nav className="main-nav">
        <div className="nav-container">
          <div className="nav-brand">
            <div className="brand-icon">
              <i className="fas fa-paper-plane"></i>
            </div>
            {/* changes in which  */}
            <div
              className="brand-text "
              onClick={() => {
                navigate("/#home");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              <span className="brand-name">Bright Wings</span>
              <span className="brand-tagline">Travel & Tourism</span>
            </div>
          </div>
          <div className="nav-menu-items">
            <a
              href="#home"
              className={`nav-link ${activeTab == "#home" && "active"}`}
            >
              Home
            </a>
            <a
              href="#destinations"
              className={`nav-link ${activeTab == "#destinations" && "active"}`}
            >
              Destinations
            </a>
            <a
              href="#services"
              className={`nav-link ${activeTab == "#services" && "active"}`}
            >
              Services
            </a>
            <a
              href="#testimonials"
              className={`nav-link ${activeTab == "#reviews" && "active"}`}
            >
              Reviews
            </a>
            <a
              href="#contact"
              className={`nav-link ${activeTab == "#contact" && "active"}`}
            >
              Contact
            </a>
          </div>
          <div className="flex items-center gap-5">
            <button
              className="btn btn--outline btn--sm"
              onClick={() => navigate("/auth")}
            >
              Sign In
            </button>
            {/* <button
              className="btn btn--primary btn--sm hidden md:block"
              onClick={() => navigate("/auth")}
            >
              Get Started
            </button> */}
          <div
            onClick={() => setToggle((prev) => !prev)}
            className="z-50 relative md:hidden text-3xl cursor-pointer"
          >
           {toggle ? <i className="fas fa-close"></i> : <i className="fas fa-bars"></i>}
          </div>
          </div>
        </div>
        <div
          className={`fixed z-40 w-full h-screen duration-300 overflow-hidden bg-white top-0 right-0  ${
            toggle ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="flex flex-col gap-3 mt-12 p-5 bg-white">
            <a
              href="#home"
              className={`nav-link ${activeTab == "#home" && "active"}`}
              onClick={() => setToggle(false)}
            >
              Home
            </a>
            <a
              href="#destinations"
              className={`nav-link ${activeTab == "#destinations" && "active"}`}
              onClick={() => setToggle(false)}
            >
              Destinations
            </a>
            <a
              href="#services"
              className={`nav-link ${activeTab == "#services" && "active"}`}
              onClick={() => setToggle(false)}
            >
              Services
            </a>
            <a
              href="#testimonials"
              className={`nav-link ${activeTab == "#reviews" && "active"}`}
              onClick={() => setToggle(false)}
            >
              Reviews
            </a>
            <a
              href="#contact"
              className={`nav-link ${activeTab == "#contact" && "active"}`}
              onClick={() => setToggle(false)}
            >
              Contact
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="hero-section">
        <div className="hero-background">
          <div className="hero-overlay"></div>
          <div className="hero-pattern"></div>
        </div>
        <div className="hero-content gap-5">
          <div className="hero-text">
            <h1 className="hero-title">
              Explore the World with
              <span className="gradient-text"> Bright Wings</span>
            </h1>
            <p className="hero-description ">
              Your trusted partner for unforgettable travel experiences.
              Discover amazing destinations, book with confidence, and create
              memories that last a lifetime with our premium travel services.
            </p>
            <div className="hero-features">
              <div className="feature-item">
                <i className="fas fa-shield-alt"></i>
                <span>Secure Booking</span>
              </div>
              <div className="feature-item">
                <i className="fas fa-star"></i>
                <span>Best Prices</span>
              </div>
              <div className="feature-item">
                <i className="fas fa-headset"></i>
                <span>24/7 Support</span>
              </div>
            </div>
            <div className="hero-actions">
              <button
                className="btn btn--primary btn--lg"
                onClick={() => navigate("/auth")}
              >
                <i className="fas fa-plane"></i>
                Start Your Journey
              </button>
              <button className="btn btn--outline-white btn--lg">
                <i className="fas fa-play"></i>
                Watch Video
              </button>
            </div>
          </div>
        </div>

        {/* Floating Stats */}
        <div className="w-full grid grid-cols-2 gap-3 sm:gap-10 max-w-[60rem] mx-auto">
          <div className="stat-card">
            <div className="stat-number">50K+</div>
            <div className="stat-label">Happy Travelers</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">200+</div>
            <div className="stat-label">Destinations</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">24/7</div>
            <div className="stat-label">Customer Support</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">99%</div>
            <div className="stat-label">Satisfaction Rate</div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services-section">
        <div className="container">
          <div className="section-header">
            <span className="section-subtitle">Our Services</span>
            <h2 className="section-title">
              Everything You Need for Your Perfect Trip
            </h2>
            <p className="section-description">
              From flights to accommodations, tours to visa services - we've got
              you covered with comprehensive travel solutions.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
            {services.map((service, index) => (
              <div
                key={index}
                className="service-card"
                onClick={() => navigate("/auth")}
              >
                <div
                  className="service-icon"
                  style={{ backgroundColor: service.color }}
                >
                  <i className={service.icon}></i>
                </div>
                <div className="service-content">
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                  <ul className="service-features">
                    {service.features.map((feature, idx) => (
                      <li key={idx}>
                        <i className="fas fa-check"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="service-action">
                  <button className="btn btn--outline btn--sm">
                    Explore More
                    <i className="fas fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Destinations Section */}
      <section id="destinations" className="destinations-section">
        <div className="container">
          <div className="section-header">
            <span className="section-subtitle">Popular Destinations</span>
            <h2 className="section-title">
              Discover Amazing Places Around the World
            </h2>
            <p className="section-description">
              From bustling cities to serene beaches, explore our handpicked
              destinations that offer unforgettable experiences.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
            {destinations.map((destination) => (
              <div
                key={destination.id}
                className="destination-card"
                onClick={() => navigate("/auth")}
              >
                <div className="destination-image">
                  <img src={destination.image} alt={destination.name} />
                  <div className="destination-overlay">
                    <div className="destination-rating">
                      <i className="fas fa-star"></i>
                      {destination.rating}
                    </div>
                    <div>

                    <button className="btn btn--primary btn--sm">
                      <i className="fas fa-heart"></i>
                      Save
                    </button>
                    </div>
                
                  </div>
                </div>
                <div className="destination-content">
                  <div className="destination-header">
                    <h3 className="destination-name">{destination.name}</h3>
                    <div className="destination-price">{destination.price}</div>
                  </div>
                  <p className="destination-description">
                    {destination.description}
                  </p>
                  <div className="destination-actions">
                    <button className="btn btn--primary btn--sm">
                      <i className="fas fa-plane"></i>
                      Book Now
                    </button>
                    <button className="btn btn--outline btn--sm">
                      <i className="fas fa-info-circle"></i>
                      Details
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="testimonials-section">
        <div className="container">
          <div className="section-header">
            <span className="section-subtitle">Customer Stories</span>
            <h2 className="section-title">What Our Travelers Say</h2>
            <p className="section-description">
              Read genuine experiences from thousands of satisfied customers who
              trusted us with their dream vacations.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <div className="testimonial-rating">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="fas fa-star"></i>
                  ))}
                </div>
                <p className="testimonial-text">"{testimonial.text}"</p>
                <div className="testimonial-author">
                  <img src={testimonial.image} alt={testimonial.name} />
                  <div className="author-info">
                    <h4 className="author-name">{testimonial.name}</h4>
                    <p className="author-location">{testimonial.location}</p>
                    <span className="author-trip">{testimonial.trip}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <div className="cta-icon">
              <i className="fas fa-paper-plane"></i>
            </div>
            <h2 className="cta-title">Ready to Start Your Adventure?</h2>
            <p className="cta-description">
              Join thousands of travelers who trust Bright Wings for their
              journeys. Create unforgettable memories with our premium travel
              services.
            </p>
            <div className="cta-actions">
              <button
                className="btn btn--primary btn--lg"
                onClick={() => navigate("/auth")}
              >
                <i className="fas fa-user-plus"></i>
                Sign Up Now
              </button>
              <button
                className="btn btn--outline-white btn--lg"
                onClick={() => navigate("/auth")}
              >
                <i className="fas fa-sign-in-alt"></i>
                Sign In
              </button>
            </div>
            <div className="cta-features">
              <div className="cta-feature">
                <i className="fas fa-check"></i>
                <span>Free Account Setup</span>
              </div>
              <div className="cta-feature">
                <i className="fas fa-check"></i>
                <span>Instant Booking Access</span>
              </div>
              <div className="cta-feature">
                <i className="fas fa-check"></i>
                <span>Exclusive Member Deals</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer id="contact" className="main-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <div className="brand-logo">
                <div className="brand-icon">
                  <i className="fas fa-paper-plane"></i>
                </div>
                <div className="brand-text">
                  <span className="brand-name">Bright Wings</span>
                  <span className="brand-tagline">Travel & Tourism</span>
                </div>
              </div>
              <p className="brand-description">
                Your trusted partner for unforgettable travel experiences. We
                create moments that become memories to last a lifetime.
              </p>
              <div className="social-links">
                <a href="#" className="social-link">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="#" className="social-link">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="#" className="social-link">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="#" className="social-link">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="#" className="social-link">
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
            </div>

            <div className="footer-links">
              <div className="footer-section">
                <h4 className="footer-title">Services</h4>
                <ul className="footer-list">
                  <li>
                    <a href="#" className="footer-link">
                      Flight Bookings
                    </a>
                  </li>
                  <li>
                    <a href="#" className="footer-link">
                      Hotel Reservations
                    </a>
                  </li>
                  <li>
                    <a href="#" className="footer-link">
                      Tour Packages
                    </a>
                  </li>
                  <li>
                    <a href="#" className="footer-link">
                      Visa Services
                    </a>
                  </li>
                  <li>
                    <a href="#" className="footer-link">
                      Travel Insurance
                    </a>
                  </li>
                </ul>
              </div>

              <div className="footer-section">
                <h4 className="footer-title">Destinations</h4>
                <ul className="footer-list">
                  <li>
                    <a href="#" className="footer-link">
                      Europe Tours
                    </a>
                  </li>
                  <li>
                    <a href="#" className="footer-link">
                      Asia Adventures
                    </a>
                  </li>
                  <li>
                    <a href="#" className="footer-link">
                      America Explorations
                    </a>
                  </li>
                  <li>
                    <a href="#" className="footer-link">
                      Africa Safaris
                    </a>
                  </li>
                  <li>
                    <a href="#" className="footer-link">
                      Ocean Cruises
                    </a>
                  </li>
                </ul>
              </div>

              <div className="footer-section">
                <h4 className="footer-title">Support</h4>
                <ul className="footer-list">
                  <li>
                    <a href="#" className="footer-link">
                      Help Center
                    </a>
                  </li>
                  <li>
                    <a href="#" className="footer-link">
                      Contact Us
                    </a>
                  </li>
                  <li>
                    <a href="#" className="footer-link">
                      Booking Support
                    </a>
                  </li>
                  <li>
                    <a href="#" className="footer-link">
                      Travel Guides
                    </a>
                  </li>
                  <li>
                    <a href="#" className="footer-link">
                      FAQ
                    </a>
                  </li>
                </ul>
              </div>

              <div className="footer-section">
                <h4 className="footer-title">Contact Info</h4>
                <div className="contact-info">
                  <div className="contact-item">
                    <i className="fas fa-phone"></i>
                    <span>+1 (555) 123-4567</span>
                  </div>
                  <div className="contact-item">
                    <i className="fas fa-envelope"></i>
                    <span>info@brightwings.com</span>
                  </div>
                  <div className="contact-item">
                    <i className="fas fa-map-marker-alt"></i>
                    <span>123 Travel St, Adventure City, AC 12345</span>
                  </div>
                  <div className="contact-item">
                    <i className="fas fa-clock"></i>
                    <span>24/7 Customer Support</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-bottom-content">
              <p className="copyright">
                &copy; 2025 Bright Wings Travel & Tourism. All rights reserved.
              </p>
              <div className="footer-bottom-links">
                <a href="#" className="footer-bottom-link">
                  Privacy Policy
                </a>
                <a href="#" className="footer-bottom-link">
                  Terms of Service
                </a>
                <a href="#" className="footer-bottom-link">
                  Cookie Policy
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
